import CryptoJS from "crypto-js";


/**
 * Generate an MD5 hash for a given string.
 * @param {string} data
 * @returns {string} MD5 hash
 */
export const signMd5 = (theData) => {
  return CryptoJS.MD5(theData).toString(); // ✅ Correct usage for MD5 hashing
};

/**
 * Encrypts data using AES-128-ECB.
 * @param {string} data - The plain text to encrypt.
 * @param {string} key - The encryption key.
 * @returns {string} - The encrypted data in hex format.
 */
export const encryptData = (data, key) => {
  const keyBytes = CryptoJS.enc.Hex.parse(key); // Convert key to bytes
  const dataBytes = CryptoJS.enc.Utf8.parse(data); // Convert data to bytes

  const encrypted = CryptoJS.AES.encrypt(dataBytes, keyBytes, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });

  return encrypted.ciphertext.toString(CryptoJS.enc.Hex); // Convert to hex
};

/**
 * Decrypts AES-128-ECB encrypted data.
 * @param {string} encryptedData - The encrypted data in hex format.
 * @param {string} key - The decryption key.
 * @returns {string} - The decrypted plain text.
 */
export const decryptData = (encryptedData, key) => {
  const keyBytes = CryptoJS.enc.Hex.parse(key); // Convert key to bytes
  const encryptedBytes = CryptoJS.enc.Hex.parse(encryptedData); // Convert hex to bytes

  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: encryptedBytes },
    keyBytes,
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    }
  );

  return decrypted.toString(CryptoJS.enc.Utf8); // Convert back to string
};
